"use strict";
/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */
function letProto(func) {
    return func(this);
}
exports.letProto = letProto;
//# sourceMappingURL=let.js.map


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/rxjs/operator/let.js
// module id = ../../../../rxjs/operator/let.js
// module chunks = 4